import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/config";

const STORAGE_KEY = "permanentTimeUtc";
const letters = new Set(["N", "A", ""]);

export type PermanentTimeRecord = {
  effectiveDate: string;
  letter: string;
};

function readRecord(): PermanentTimeRecord | null {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    if (!parsed || typeof parsed !== "object") return null;
    const effectiveDate = String(parsed.effectiveDate || "");
    const letter = String(parsed.letter || "");
    if (!/^\d{4}-\d{2}-\d{2}$/.test(effectiveDate) || !letters.has(letter)) return null;
    return { effectiveDate, letter };
  } catch {
    return null;
  }
}

export function rememberPermanentTime(data: Partial<PermanentTimeRecord> | null): void {
  const effectiveDate = String(data?.effectiveDate || "");
  const letter = String(data?.letter || "");
  if (!/^\d{4}-\d{2}-\d{2}$/.test(effectiveDate) || !letters.has(letter)) {
    localStorage.removeItem(STORAGE_KEY);
    return;
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ effectiveDate, letter }));
}

/** The certificate offset plus the permanent letter, once the effective date has arrived. */
export function permanentUtc(now: Date, offset: string): string {
  const record = readRecord();
  if (!record) return "";
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const today = `${now.getFullYear()}-${month}-${day}`;
  if (today < record.effectiveDate) return "";
  return `${offset}${record.letter}`;
}

export function watchPermanentTime(): () => void {
  return onSnapshot(
    doc(db, "systemConfig", "permanentTime"),
    (snap) => {
      rememberPermanentTime(snap.exists() ? snap.data() as Partial<PermanentTimeRecord> : null);
    },
    () => {
      // Keep the last saved record while the register is offline.
    }
  );
}
